export default "__VITE_ASSET__oR6WQpjU__"